// extracted by mini-css-extract-plugin
export var body = "_2e-8";
export var button = "_2e-0";
export var closeButton = "_2e-5";
export var content = "_2e-3";
export var empty = "_2e-f";
export var grid = "_2e-c";
export var header = "_2e-4";
export var icon = "_2e-1";
export var option = "_2e-d";
export var optionSelected = "_2e-e";
export var overlay = "_2e-2";
export var searchIcon = "_2e-a";
export var searchInput = "_2e-b";
export var searchWrapper = "_2e-9";
export var title = "_2e-6";
export var visuallyHidden = "_2e-7";